export default {
  Titulo: "Contador",
  Campos: {
    Id: {
      Tipo: "text",
      TipoInput: "hidden"
    },
    CgcCpf: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: 'CNPJ/CPF',
      Tooltip: 'CNPJ/CPF',
      Obrigatorio: true
    },
    Nome: {
      Tipo: "text",
      Label: "Nome",
      Tooltip: "Nome",
      Placeholder: "Nome",
      Obrigatorio: true
    },
    Email: {
      Tipo: "text",
      TipoInput: "email",
      Label: "E-mail",
      Tooltip: "E-mail do Contador",
      Tamanho: 80,
    },
    Telefone: {
      Tipo: "mask",
      Mascara: "TELEFONE",
      Label: "Telefone",
      Placeholder: "Telefone",
      Tooltip: "Telefone"
    },
    RgInscricaoEstadual: {
      Tipo: "text",
      Label: "RG/IE",
      Placeholder: "RG/IE",
      Obrigatorio: true,
      Tooltip: "RG/IE"
    }
  }
};
